/* ===========================================================================
   DRP Media — shared apparel size ordering
   ---------------------------------------------------------------------------
   Sizes coming from the S&S Activewear catalog arrive in arbitrary order.
   This exposes a single canonical sort so EVERY place that renders sizes
   (product page size buttons, blank-mode size grid, etc.) shows them in
   logical apparel order: YXS…YXL, XS, S, M, L, XL, 2XL…6XL, One Size last.
   Numeric sizes (pants/hats: 28, 30, 32…) sort numerically.

   Exposed as window.DRPSizeSort:
     .SIZE_ORDER          the rank lookup table
     .rank(value)         numeric rank for a single size string
     .compare(a, b)       comparator for two size strings
     .sortSizes(arr)      sort an array of size strings in place (returns it)
     .sortBy(arr, getVal) sort an array of objects by a size accessor
   =========================================================================== */
(function () {
  'use strict';

  var SIZE_ORDER = {
    // Youth — always before adult
    'YXS': 1, 'YS': 2, 'YM': 3, 'YL': 4, 'YXL': 5,
    'YOUTH XS': 1, 'YOUTH S': 2, 'YOUTH M': 3, 'YOUTH L': 4, 'YOUTH XL': 5,
    // Adult
    'XS': 10, 'X-SMALL': 10, 'XSMALL': 10, 'EXTRA SMALL': 10,
    'S': 11, 'SM': 11, 'SMALL': 11,
    'M': 12, 'MD': 12, 'MED': 12, 'MEDIUM': 12,
    'L': 13, 'LG': 13, 'LARGE': 13,
    'XL': 14, 'X-LARGE': 14, 'XLARGE': 14, 'EXTRA LARGE': 14, '1XL': 14,
    '2XL': 15, 'XXL': 15, '2X': 15, '2X-LARGE': 15,
    '3XL': 16, 'XXXL': 16, '3X': 16, '3X-LARGE': 16,
    '4XL': 17, 'XXXXL': 17, '4X': 17, '4X-LARGE': 17,
    '5XL': 18, '5X': 18, '5X-LARGE': 18,
    '6XL': 19, '6X': 19, '6X-LARGE': 19,
    // One Size variants — always last
    'OS': 100, 'OSFA': 100, 'ONE SIZE': 100, 'ONE SIZE FITS ALL': 100,
    'OSFM': 100, 'ONESIZE': 100
  };

  // Unknown non-numeric sizes land in the middle, before One Size.
  var DEFAULT_RANK = 50;

  function rank(value) {
    var key = String(value == null ? '' : value).toUpperCase().trim();
    if (Object.prototype.hasOwnProperty.call(SIZE_ORDER, key)) {
      return SIZE_ORDER[key];
    }
    return DEFAULT_RANK;
  }

  function compare(a, b) {
    var na = parseFloat(a);
    var nb = parseFloat(b);
    var aNum = !isNaN(na) && isFinite(a);
    var bNum = !isNaN(nb) && isFinite(b);
    // Both purely numeric (e.g. waist sizes 28/30/32) → numeric order.
    if (aNum && bNum) return na - nb;
    // Numeric sorts before lettered sizing only when truly numeric on both;
    // mixed sets fall back to the rank table so e.g. "OS" stays at the end.
    return rank(a) - rank(b);
  }

  function sortSizes(arr) {
    return arr.sort(compare);
  }

  function sortBy(arr, getVal) {
    return arr.sort(function (x, y) {
      return compare(getVal(x), getVal(y));
    });
  }

  window.DRPSizeSort = {
    SIZE_ORDER: SIZE_ORDER,
    rank: rank,
    compare: compare,
    sortSizes: sortSizes,
    sortBy: sortBy
  };
})();
